import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function animFunction() {
	if($(".wp-block-krutablocks-scroll-anim").length) {
		$(".wp-block-krutablocks-scroll-anim").each(function() {
			var self = $(this),
				inner = self.find(".wp-block-krutablocks-scroll-anim__inner");

			let tl, startA;

			if(self.hasClass("anim-f-in")) {
				tl = gsap.fromTo(self,{autoAlpha:0},{duration:0.6,autoAlpha:1});
			} else if(self.hasClass("anim-reveal-l")) {
				gsap.set(self,{autoAlpha:1});
				tl = gsap.timeline({paused:true})
			    .fromTo(self, {xPercent:-100},{duration:0.6,xPercent:0})
			    .fromTo(inner, {xPercent:100},{duration:0.6,xPercent:0}, "<");
			} else if(self.hasClass("anim-reveal-t")) {
				gsap.set(self,{autoAlpha:1});
				tl = gsap.timeline({paused:true})
			    .fromTo(self, {yPercent:-100},{duration:0.6,yPercent:0})
			    .fromTo(inner, {yPercent:100},{duration:0.6,yPercent:0}, "<");
			} else if(self.hasClass("anim-fade-up")) {
				tl = gsap.fromTo(self,{y:-40,autoAlpha:0},{duration:0.6,y:0,autoAlpha:1});
			} else if(self.hasClass("anim-fade-down")) {
				tl = gsap.fromTo(self,{y:40,autoAlpha:0},{duration:0.6,y:0,autoAlpha:1});
			}
			var st = ScrollTrigger.create({
				trigger: self,
				start: "+=160 bottom",
				// markers: {startColor: "blue", endColor: "yellow", indent: 100},
    // 			toggleActions: "play reverse play reverse",
				animation: tl
			});
		});
	}
}

$(window).on('load', () => {
  if($('.c-loader').length) {
    setTimeout(() => { 
          animFunction();
      }, 3200);
  } else {
    setTimeout(() => { 
          animFunction();
      }, 400);
  }
})